var c = /* @__PURE__ */ ((r) => (r.ACTIVE = "active", r.COMPLETED = "completed", r.UPCOMING = "upcoming", r))(c || {});
export {
  c as StepState
};
